import request from '@/plugins/axios'

//获取图片列表
export function listPicture(params) {
  return request({
    url: '/picture/listPicture',
    method: 'get',
    params
  })
}

//获取未整理图片列表
export function listUnclutteredPicture(params) {
  return request({
    url: '/picture/listUnclutteredPicture',
    method: 'get',
    params
  })
}

//获取指定图集中图片列表
export function listAtlasPictures(params) {
  return request({
    url: '/picture/listAtlasPictures',
    method: 'get',
    params
  })
}

//添加图片
export function addPicture(data) {
  return request({
    url: '/picture/addPicture',
    method: 'post',
    data
  })
}

//删除图片
export function deletePicture(params) {
  return request({
    url: '/picture/deletePicture/' + params,
    method: 'get'
  })
}

//删除图到回收站
export function removePicturePic(params) {
  return request({
    url: '/picture/removePicture/' + params,
    method: 'get'
  })
}

//查询单个图片
export function getPicture(params) {
  return request({
    url: '/picture/getPicture/' + params,
    method: 'get'
  })
}

//修改图片信息
export function updatePicture(data) {
  return request({
    url: '/picture/updatePicture',
    method: 'post',
    data
  })
}

//绑定图集
export function bindingAtlas(params) {
  return request({
    url: '/picture/bindingAtlas',
    method: 'post',
    params
  })
}



//查询多个图片
export function getPictures(params) {
  return request({
    url: '/picture/getPictures',
    method: 'get',
    params
  })
}


//批量移动图集
export function batchUpdatePicture(params,data) {
  return request({
    url: '/picture/batchUpdatePicture',
    method: 'post',
    params,
    data
  })
}

//批量修改图片信息
export function batchUpdatePictureInfo(params,data) {
  return request({
    url: '/picture/batchUpdatePictureInfo',
    method: 'post',
    params,
    data
  })
}



//获取单个图片日志
export function getPictureLog(params) {
  return request({
    url: '/picture/getPictureLog',
    method: 'get',
    params
  })
}






//批量添加图片操作日志
export function batchAddLog(data) {
  return request({
    url: '/picture/batchAddLog',
    method: 'post',
    data
  })
}




//获取回收站图片列表
export function listRecyclePicture(params) {
  return request({
    url: '/picture/listRecyclePicture',
    method: 'get',
    params
  })
}


//恢复回收站的图片
export function recyclePicture(params) {
  return request({
    url: '/picture/recyclePicture',
    method: 'post',
    params
  })
}